module.exports = __webpack_public_path__ + "static/media/logo-en-f.2bab8b87.svg";